import * as React from 'react';
import { Field, Form } from 'react-final-form';

import Input from '../Input';
import PhoneInput from '../PhoneInput';
import { BaseButton } from '../BaseComponents';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme';
import { useCustomerContactsValidation } from './hooks';

export interface Props {
	initialValues?: Partial<Contacts>;
	onContactsSubmit: (values: Contacts) => Promise<void>;
	isLoading: boolean;
}

export interface Contacts {
	email: string;
	phone: string;
}

const CustomerContactsForm: React.FC<Props> = props => {
	const { t } = useTranslation('CustomerContactsForm');
	const { CustomerContactsForm: theme } = useTheme('CustomerContactsForm');
	const { testEmail, testPhone } = useCustomerContactsValidation();

	const initialValues: Contacts = {
		email: props.initialValues?.email || '',
		phone: props.initialValues?.phone || ''
	};

	return (
		<Form<Contacts> initialValues={initialValues} onSubmit={props.onContactsSubmit}>
			{({ handleSubmit, values, hasValidationErrors }) => (
				<form onSubmit={handleSubmit} className={theme.form}>
					<Field name="email" type="email" validate={testEmail}>
						{field => (
							<Input
								inputClassName={theme.email__input}
								className={theme.email}
								{...field}
								label={t('Email')}
								absoluteHintPosition={true}
								TextFieldProps={{
									...field.input,
									onChange: e => field.input.onChange(e),
									error: field.meta.touched && field.meta.error,
									helperText: field.meta.touched && field.meta.error
								}}
							/>
						)}
					</Field>
					<Field name="phone" validate={testPhone}>
						{field => (
							<>
								<PhoneInput
									{...field.input}
									className={theme.phone__input}
									textFieldsProps={{
										...field.input,
										onChange: e => field.input.onChange(e),
										error: field.meta.touched && field.meta.error,
										label: t('Phone'),
										helperText: field.meta.touched && field.meta.error
									}}
								/>
							</>
						)}
					</Field>
					<BaseButton
						isLoading={props.isLoading}
						variant="optionAction"
						className={theme.button}
						type={'submit'}
					>
						{t('Done')}
					</BaseButton>
				</form>
			)}
		</Form>
	);
};

export default CustomerContactsForm;
